import type { IconProps } from '../types/IconProps.ts';
export const ChevronsDownUp: IconProps = {
    name: 'ChevronsDownUp',
    children: [
        `<path d="m7 4 4.7 4.87a.4.4 0 0 0 .6 0L17 4M7 20l4.65-4.65c.2-.2.5-.2.7 0L17 20" />`,
    ]
};